// src/components/order/detail-actions.tsx
import { Button } from "@mantine/core";
import { useSelector } from "react-redux";
import { useTranslation } from "react-i18next";
import { IAuth } from "../../store/Auth";
import { usePermission } from "../permission";
import { DetailActionsProps } from "./types";

export function DetailActions({ data, onAction }: DetailActionsProps) {
  const { t } = useTranslation("order");
  const { user } = useSelector((state: { auth: IAuth }) => state.auth);
  const ORD_PO_ACCEPT = usePermission("ORD_PO_ACCEPT");
  const ORD_PO_LIST = usePermission("ORD_PO_LIST");

  const isReceiver = user?.currentBusiness?.id === data?.receiverBusiness?.id;
  const isSender = user?.currentBusiness?.id === data?.senderBusiness?.id;
  const isReviewed = data?.orderStatus === "REVIEWED";
  const isRegistered = data?.orderStatus === "REGISTERED";

  return (
    <>
      {ORD_PO_ACCEPT.hasAccess && (
        <Button
          onClick={() => onAction("approve")}
          disabled={!(isReviewed && isReceiver)}
          variant="outline"
          color="brand"
        >
          {t("actions.approve")}
        </Button>
      )}
      {ORD_PO_ACCEPT.hasAccess && (
        <Button
          onClick={() => onAction("reject")}
          disabled={!(isReviewed && isReceiver)}
          variant="outline"
          color="red"
        >
          {t("actions.reject")}
        </Button>
      )}
      {ORD_PO_LIST.hasAccess && (
        <Button
          onClick={() => onAction("review")}
          variant="outline"
          disabled={!(isRegistered && isSender)}
        >
          {t("actions.review")}
        </Button>
      )}
    </>
  );
}
